import type { ExperimentalQueries } from '../__types__/ExperimentalQueries';
import { fetchJSON } from '../fetchJSON';
import { MediaType } from '../MediaType';

export const experimentalMacroPlaceholderADF: ExperimentalQueries['experimentalMacroPlaceholderADF'] =
	(_, { macroDefinition, contentId }, { network }) =>
		fetchJSON(network, `/wiki/rest/internal/1.0/macro/placeholder`, {
			body: JSON.stringify({ macro: JSON.parse(macroDefinition), contentId }),
			method: 'POST',
			headers: {
				'Content-Type': MediaType.JSON,
			},
		}).then(
			/* onFulfilled */ (json) => ({
				json: JSON.stringify(json),
			}),
			/* onRejected */ (reason) => {
				if (network.BadStatusError.isBadStatusError(reason)) {
					return {
						json: '',
					};
				}
				throw reason;
			},
		);
